/**
 * Sidebar customisation registry (2026-08-10). ONE list of the nav items a
 * user may hide, shared by the sidebar (Layout) and the Settings → My Menu
 * tab so they can never drift. Landing pages (Dashboard/Today), Search,
 * Settings and My Profile are deliberately not listed — hiding your own way
 * back into the app is a support call, and the API whitelist refuses their
 * keys anyway (HIDEABLE_NAV_KEYS in api routes/auth.js — keep in sync).
 *
 * Hiding is cosmetic and desktop-only: routes stay open, and the mobile
 * More sheet always lists everything the role can reach.
 */
export function navCustomiseItems(caps) {
  return [
    { key: 'customers', label: 'Customers', show: true },
    { key: 'distributors', label: 'Distributors', show: !!(caps.view_distributors || caps.manage_distributors) },
    { key: 'pipeline', label: 'Commercial', show: !!caps.use_pipeline },
    { key: 'inbox', label: 'Inbox', show: !!caps.use_inbox },
    { key: 'tickets', label: 'Jobs & Tickets', show: caps.use_service_desk !== false },
    { key: 'assets', label: 'Assets', show: true },
    { key: 'scheduling', label: 'Scheduling', show: caps.use_scheduling !== false },
    // Ops Planning Board (2026-10-16): every role sees it.
    { key: 'ops_board', label: 'Ops Planning', show: caps.use_ops_board !== false },
    { key: 'engineers', label: 'Engineers', show: !!caps.see_team },
    { key: 'reports', label: 'Reports', show: !!caps.view_reports },
    { key: 'map', label: 'Map', show: !!caps.use_map },
    { key: 'on_call', label: 'On Call', show: !!caps.use_on_call },
    { key: 'payroll', label: 'Payroll', show: !!caps.view_payroll && !caps.use_on_call },
    { key: 'approvals', label: 'Approvals', show: true },
    { key: 'stays', label: 'Accommodation', show: true },
    // Engineer bulletins (2026-09-13): open to every role.
    { key: 'bulletins', label: 'Bulletins', show: true },
    { key: 'help', label: 'Help', show: true }
  ];
}
